import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-sub-speciality-master',
  templateUrl: './add-sub-speciality.component.html',
  styleUrls: ['./add-sub-speciality.component.scss']
})
export class AddSubSpecialityMasterComponent implements OnInit {

  addTitle = true;
  editTitle;
  addForm: FormGroup;
  submitted = false;
  specialities: any[];
  constructor(private formBuilder: FormBuilder, private masterService: MasterService,
    private loaderService: LoaderService, private toasterService: ToastrService) {
    this.getFormGroup();
  }

  ngOnInit() {
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
  }


  get f() { return this.addForm.controls; }
  private getFormGroup() {
    this.addForm = this.formBuilder.group({
      'id': new FormControl(),
      'spId': new FormControl(),
      'code': new FormControl(),
      'descEn': new FormControl(),
      'desc': new FormControl(),
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl()
    })
  }

  save() {
    let saveData = {};
    this.submitted = true;
    if (this.addForm.invalid) {
      return;
    }
    saveData["master"] = this.addForm.value;
    saveData["masterShName"] = "SUB_SPECIALITY";

    this.loaderService.display(true);
    this.masterService.saveMaster(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"] == 0) {
        this.addForm.patchValue({ cotryId: response['result'] });
        this.toasterService.success(response['message'], 'Success');
      } else {
        this.toasterService.error(response['message'], 'Error');
      }
    },
      error => {
        this.loaderService.display(false);
      })
  }
}
